<template>
<mm-tab-title v-model="tab" :titles="titles">
    <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
    <div>
        <el-form ref="form" :model="result" size="small" label-width="200px">
        
            <div v-show="tab===1">
                <el-form-item label="Channel Name" prop="channel_name"  required>
                    <el-input v-model="result.channel_name" :readonly="edit" />
                </el-form-item>
                <el-form-item label="Channel Type" required prop="channel_type">
                    <mm-channel-type v-model="result.channel_type" />
                </el-form-item>
                <el-form-item label="Account Level" required prop="account_level">
                    <mm-channel-accountlevel v-model="result.account_level" />
                </el-form-item>
                <el-form-item label="Geo" required prop="geo">
                    <mm-offer-geos v-model="result.geo" />
                </el-form-item>
                <el-form-item label="Status" prop="status" required>
                    <el-radio-group v-model="result.status">
                        <el-radio label='active'>active</el-radio>
                        <el-radio label='pending'>pending</el-radio>
                        <el-radio label='paused'>paused</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Deduction Rate(%)" prop="defraud"  required>
                    <mm-input-number-percent type="number" @mousewheel.native.prevent v-model="result.defraud" limit_min="-3"/>
                </el-form-item>
                <el-form-item label="Payout Rate(%)" prop="price_percent"  required>
                    <mm-input-number-percent type="number" @mousewheel.native.prevent v-model="result.price_percent" limit_min="0"/>
                </el-form-item>
                <el-form-item label="Login User Name" prop="user_name"  required>
                    <el-input v-model="result.user_name"/>
                </el-form-item>
                <el-form-item label="Login User Email" prop="email" type="email"  required>
                    <el-input v-model="result.email" auto-complete="new-password"/>
                </el-form-item>
                <!-- <el-form-item label="Login Password" prop="login_passwd" v-show="!edit">
                    <el-input v-model="result.login_passwd" type="password" auto-complete="new-password"/>
                </el-form-item> -->
                <el-form-item label="Account Manager" required prop="account_manager">
                    <mm-users v-model="result.account_manager" />
                </el-form-item>
                <el-form-item label="Business Manager" required prop="business_manager">
                    <mm-users v-model="result.business_manager" />
                </el-form-item>
                <el-form-item label="Client Finance Email" prop="client_finance_email" type="email" >
                    <el-input v-model="result.client_finance_email" />
                </el-form-item>
                <el-form-item label="Client Dashboard Addr" prop="client_dashboard_addr" >
                    <el-input v-model="result.client_dashboard_addr" placeholder="http://..." />
                </el-form-item>
                <el-form-item label="IO" prop="io" >
                    <mm-upload v-model="result.io_file" dir="channel"></mm-upload>
                </el-form-item>
                <el-form-item label="Remark" prop="remark"  >
                    <el-input v-model="result.remark" type="textarea" :rows="5" />
                </el-form-item>
            </div>
            <div v-show="tab===2">
                <el-form-item label="Conversion Postback URL" prop="postback">
                    <mm-channel-postback v-model="result.postback" />
                </el-form-item>
                <el-form-item label="Event Postback URL" prop="event_pb">
                    <el-input v-model="result.event_pb" />
                </el-form-item>
                <el-form-item label="App Name(Android)" prop="gp_app_name">
                    <el-input v-model="result.gp_app_name"/>
                </el-form-item>
                <el-form-item label="App Name(IOS)" prop="ios_app_name">
                    <el-input v-model="result.ios_app_name"/>
                </el-form-item>
            </div>
            <div v-show="tab===3&&edit">
                <el-form-item label="Is Change Password">
                    <el-switch v-model="is_change_pwd"></el-switch>
                </el-form-item>
                <el-form-item label="New password">
                    <el-input v-model="new_password" type="password" show-password/>
                </el-form-item>
                <el-form-item label="Confirm password">
                    <el-input v-model="confirm_password" type="password" show-password/>
                </el-form-item>
            </div>
        </el-form>
        </div>
</mm-tab-title>

</template>

<script>
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
		return {
			result: {
				status: 'active',
			},
			tab: 1,
			is_change_pwd:false,
			new_password:'',
			confirm_password:'',
			file_list:[],
			titles:['Base Info','Tracking Info']
		};
	},
	methods: {
		async submit() {
			await this.$validate(this.$refs.form);
			if(this.is_change_pwd == true){
				if(this.new_password == this.confirm_password){
					this.result.login_passwd = this.new_password;
				}
				else{
					this.$message({
						type:'error',
						message:'Inconsistent password',
					})
					return;
				}
			}
			if (this.result.postback == null) {
				this.result.postback = JSON.stringify({ all: [] });
			}
            if (!this.edit) {
                this.result.login_passwd = this.result.channel_name + '@pikakads$123!';
            }
			const request_path = this.edit?'/channel/update':'/channel/create';
			const result = await this.$post(request_path,this.result);
			if(this.edit){
				this.loadData();
			}else{
				this.$router.push({ path: "/channelEdit",query:{id:result} });
			}
            
		},
		async loadData(){
			if (this.edit) {
				const id= this.$route.query['id'];
				this.result = await this.$post('/channel/detail',{channel_id:id});

			}
		}
	},
    
	beforeMount() {
		this.loadData();
		if(this.edit){
			this.titles.push('Change Password');
		}
	}
};
</script>